export default {
  BASE_URL: '/sysDepartment',
  api: [{
      name: 'getDepartment',
      method: 'GET',
      desc: '获取部门',
      path: '/getDepartment',
    },
    {
      name: 'detail',
      method: 'GET',
      desc: '新增下级部门（前置）',
      path: '/department/detail'
    },
    {
      name: 'add',
      method: 'POST',
      desc: '新增下级部门',
      path: '/add'
    },
    {
      name: 'edit',
      method: 'POST',
      desc: '编辑部门',
      path: '/edit'
    },
    {
      name: 'getSubordinateDepartment',
      method: 'GET',
      desc: '获取下级部门',
      path: '/getSubordinateDepartment'
    },
    {
      name: 'delete',
      method: 'POST',
      desc: '删除部门',
      path: '/delete'
    },
    {
      name: 'getDepartmentUser',
      method: 'GET',
      desc: '获取当前部门员工',
      path: '/getDepartmentUser'
    },
    {
      name: 'getUser',
      method: 'GET',
      desc: '获取员工列表',
      path: '/getUser'
    },
    {
      name: 'role',
      method: 'GET',
      desc: '获取员工角色',
      path: '/user/role'
    },
    {
      name: 'addUser',
      method: 'POST',
      desc: '新增员工',
      path: '/addUser'
    },
    {
      name: 'deleteUser',
      method: 'POST',
      desc: '解绑员工',
      path: '/deleteUser'
    },
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/sys/organization.js